import { Component, input, output, computed, model } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class PaginationComponent {
  // Signal-based inputs
  collectionSize = input<number>(0);
  maxSize = input<number>(5);
  itemsPerPage = input<number>(10);

  // Two-way binding for page
  page = model<number>(1);

  // Output event
  pageChange = output<number>();

  // Computed total pages
  totalPages = computed(() => Math.ceil(this.collectionSize() / this.itemsPerPage()));

  // Computed page numbers to display
  pages = computed(() => {
    const pages: number[] = [];
    const total = this.totalPages();
    const current = this.page();
    const max = this.maxSize();

    const startPage = Math.max(1, current - Math.floor(max / 2));
    const endPage = Math.min(total, startPage + max - 1);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  });

  goToPage(pageNumber: number): void {
    const current = this.page();
    const total = this.totalPages();

    if (pageNumber >= 1 && pageNumber <= total && pageNumber !== current) {
      this.page.set(pageNumber);
      this.pageChange.emit(pageNumber);
    }
  }

  previousPage(): void {
    this.goToPage(this.page() - 1);
  }

  nextPage(): void {
    this.goToPage(this.page() + 1);
  }
}
